import {ElementRef, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {StyleMap} from '../util/app.types';


export type LoadingState = {
  loading?: boolean;
  message?: string;
  overlayStyle?: StyleMap;
  messageStyle?: StyleMap;
  showSpinner?: boolean;
  spinnerSize?: 'sm' | 'md' | 'lg';
  targetElement?: ElementRef;
}

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loadingSubject = new BehaviorSubject<LoadingState>({loading: false});

  private messageSubject = new BehaviorSubject<LoadingState>({});

  public loading = this.loadingSubject.asObservable();

  public message = this.messageSubject.asObservable();

  public showLoading(config?: string | LoadingState): void{

    // console.log('showLoading', config);

    let state: LoadingState = {loading: true};
    if (!!config){
      if (typeof config === 'string'){
        state.message = config;
      }else{
        state = config;
        state.loading = true;
        state.showSpinner = config.showSpinner ?? true;
      }
    }
    // console.log('showLoading state', state);

    this.loadingSubject.next(state);
  }

  public hideLoading(): void{
    this.loadingSubject.next({loading: false});
  }

  public updateMessage(message: string): void{
    this.messageSubject.next({message: message});
  }

}
